import { useTranslation } from 'react-i18next';

import { LANGUAGE_KEYS } from 'config/languageKeys';
import { YOUR_CURRENT_PIN_ID } from 'config/testID';

const {
    SYSTEM_PIN_ENTRY_SCREEN_TITLE,
    SYSTEM_PIN_ENTRY_SCREEN_BODY,
    SYSTEM_PIN_ENTRY_SCREEN_BLOCKED_TITLE,
    SYSTEM_PIN_ENTRY_SCREEN_BLOCKED_BODY,
    SYSTEM_PIN_ENTRY_SCREEN_RE_ENTER_TITLE,
    SYSTEM_PIN_ENTRY_SCREEN_RE_ENTER_BODY,
    CHANGE_SYSTEM_PIN_SCREEN_TITLE,
    CHANGE_SYSTEM_PIN_SCREEN_BODY,
    CHANGE_SYSTEM_PIN_SCREEN_RE_ENTER_TITLE,
    CHANGE_SYSTEM_PIN_SCREEN_RE_ENTER_BODY,
    CHANGE_SYSTEM_PIN_SCREEN_INCORRECT_PIN_TITLE,
    CHANGE_SYSTEM_PIN_SCREEN_INCORRECT_PIN_BODY,
} = LANGUAGE_KEYS;

export enum PinDialogStatus {
    BLOCKED = 'BLOCKED',
    INCORRECT = 'INCORRECT',
    NEW_PIN = 'NEW_PIN',
    CONFIRM_NEW_PIN = 'CONFIRM_NEW_PIN',
    NEW_PIN_DOESNT_MATCH = 'NEW_PIN_DOESNT_MATCH',
    ENTER_PIN = 'ENTER_PIN',
    FTI_CREATE_PIN = 'FTI_CREATE_PIN',
    FTI_CONFIRM_CREATE_PIN = 'FTI_CONFIRM_CREATE_PIN',
}

export default function getPinDialogText(status: PinDialogStatus): {
    title: string;
    description: string;
    testID: string;
} {
    const { t } = useTranslation();

    let title = '';
    let description = '';
    let testID = '';

    if (status === PinDialogStatus.BLOCKED) {
        title = SYSTEM_PIN_ENTRY_SCREEN_BLOCKED_TITLE;
        description = SYSTEM_PIN_ENTRY_SCREEN_BLOCKED_BODY;
    } else if (status === PinDialogStatus.INCORRECT) {
        title = SYSTEM_PIN_ENTRY_SCREEN_RE_ENTER_TITLE;
        description = SYSTEM_PIN_ENTRY_SCREEN_RE_ENTER_BODY;
    } else if (
        status === PinDialogStatus.NEW_PIN ||
        status === PinDialogStatus.FTI_CREATE_PIN
    ) {
        title = CHANGE_SYSTEM_PIN_SCREEN_TITLE;
        description = CHANGE_SYSTEM_PIN_SCREEN_BODY;
    } else if (
        status === PinDialogStatus.CONFIRM_NEW_PIN ||
        status === PinDialogStatus.FTI_CONFIRM_CREATE_PIN
    ) {
        title = CHANGE_SYSTEM_PIN_SCREEN_RE_ENTER_TITLE;
        description = CHANGE_SYSTEM_PIN_SCREEN_RE_ENTER_BODY;
    } else if (status === PinDialogStatus.NEW_PIN_DOESNT_MATCH) {
        title = CHANGE_SYSTEM_PIN_SCREEN_INCORRECT_PIN_TITLE;
        description = CHANGE_SYSTEM_PIN_SCREEN_INCORRECT_PIN_BODY;
    } else if (status === PinDialogStatus.ENTER_PIN) {
        title = SYSTEM_PIN_ENTRY_SCREEN_TITLE;
        description = SYSTEM_PIN_ENTRY_SCREEN_BODY;
        testID = YOUR_CURRENT_PIN_ID;
    }

    return {
        title: t(title),
        description: t(description),
        testID,
    };
}
